import type { ImageSources } from '@/components/Image/ArtDirectedImage';
import type { FrontifyImageContent } from '@/contentful';
import { ViewportSize } from '@/styles/viewportSize';

export const getImages = (
  images: FrontifyImageContent[]
): ImageSources | undefined => {
  let srcSet: ImageSources | undefined;

  // biome-ignore lint/suspicious/noDoubleEquals: Automated migration to Biome
  if (images.length == 1) {
    srcSet = {
      xs: [images[0], ViewportSize.lg],
      fallback: [images[0], ViewportSize.lg],
    };
  }

  // biome-ignore lint/suspicious/noDoubleEquals: Automated migration to Biome
  if (images.length == 2) {
    srcSet = {
      md: [images[0], ViewportSize.lg],
      xs: [images[1], ViewportSize.md],
      fallback: [images[1], ViewportSize.lg],
    };
  }

  return srcSet;
};
